// Official SELLEXR logo composition.
// - Circular S mark: /brand/mark.png (1024×1024 upscale of the official brand mark;
//   inner white curve of S preserved as pure #FFFFFF).
// - Wordmark: the OFFICIAL "SELLEXR" wordmark image supplied by the user — used as-is,
//   never recreated with fonts. Two variants:
//     /brand/wordmark.png       — navy "SELLEX" + orange "R" for light backgrounds
//     /brand/wordmark-white.png — white "SELLEX" + orange "R" for dark backgrounds
// - Tagline: rendered as real text so it stays crisp; letter spacing & color match the brand.
export function Logo({ variant = "default", size = "md" }) {
  // variant: "default" (light bg) | "white" (dark bg) | "mark"
  const scale = { sm: 0.72, md: 1, lg: 1.35, xl: 1.7 }[size] || 1;
  const markPx = Math.round(44 * scale);
  const wordHeightPx = Math.round(22 * scale);
  const taglinePx = Math.round(8.5 * scale);
  const gap = Math.round(12 * scale);
  const trackLetterSpacing = Math.max(0.5, 1.4 * scale);

  const orange = "#FF6A00";
  const taglineColor = variant === "white" ? "rgba(255,255,255,0.78)" : "rgba(15,23,42,0.58)";
  const wordmarkSrc = variant === "white" ? "/brand/wordmark-white.png" : "/brand/wordmark.png";

  if (variant === "mark") {
    return (
      <img
        src="/brand/mark.png"
        alt="SELLEXR"
        width={markPx}
        height={markPx}
        style={{ width: markPx, height: markPx, display: "block" }}
        data-testid="logo"
        draggable={false}
      />
    );
  }

  return (
    <div className="flex items-center select-none" style={{ gap }} data-testid="logo">
      <img
        src="/brand/mark.png"
        alt=""
        width={markPx}
        height={markPx}
        style={{ width: markPx, height: markPx, display: "block", flexShrink: 0 }}
        draggable={false}
      />
      <div className="flex flex-col" style={{ lineHeight: 1 }}>
        <img
          src={wordmarkSrc}
          alt="SELLEXR"
          height={wordHeightPx}
          style={{ height: wordHeightPx, width: "auto", display: "block" }}
          draggable={false}
        />
        <span
          style={{
            marginTop: Math.max(3, 4 * scale),
            fontFamily: "'Space Grotesk', 'Inter', sans-serif",
            fontWeight: 500,
            fontSize: taglinePx,
            letterSpacing: `${trackLetterSpacing}px`,
            color: taglineColor,
            textTransform: "uppercase",
            whiteSpace: "nowrap",
          }}
        >
          CONNECT <span style={{ color: orange }}>·</span> MANAGE <span style={{ color: orange }}>·</span> GROW
        </span>
      </div>
    </div>
  );
}
